import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { HttpErrorResponse } from '@angular/common/http'
import { CallerService } from '../services/caller.service'

type VerifyEmailStatus = 'verifying' | 'success' | 'error'

@Component({
    selector: 'app-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.css'],
})
export class VerifyEmailComponent implements OnInit {
    status: VerifyEmailStatus = 'verifying'
    message: string = ''
    isResending: boolean = false
    resendSent: boolean = false

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private callerService: CallerService,
    ) {}

    ngOnInit(): void {
        const token = this.route.snapshot.queryParamMap.get('token')

        if (!token) {
            this.status = 'error'
            this.message = 'This verification link is missing its token.'
            return
        }

        this.callerService.verifyEmail(token).subscribe({
            next: (res: any) => {
                this.status = 'success'
                this.message = res?.body?.message ?? 'Your email has been verified.'
            },
            error: (err: HttpErrorResponse) => {
                this.status = 'error'
                this.message = err?.error?.message ?? 'This verification link is invalid or has expired.'
            },
        })
    }

    resend(): void {
        this.isResending = true

        this.callerService.resendVerificationEmail().subscribe({
            next: (res: any) => {
                this.isResending = false
                this.resendSent = true
                this.callerService.showNotification(res?.body?.message ?? 'Verification email sent.')
            },
            error: (err: HttpErrorResponse) => {
                this.isResending = false

                if (err.status === 401) {
                    this.callerService.showNotification('Please log in to resend the verification email.')
                    this.router.navigate(['/login'])
                    return
                }

                this.callerService.showNotification(err?.error?.message ?? 'Failed to resend verification email.')
            },
        })
    }
}
